import { Outlet } from "react-router-dom";
import Navbar from "components/main/Navbar/Navbar";
import Footer from "components/main/Footer/Footer";
export default function Layout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
